import tw from "twin.macro"

export const H3 = tw.h3`
  text-xl
  font-sans
  font-semibold
  mt-4
`
